import useRudderStackTrack from 'hooks/useRudderStackTrack';
import { atom, useAtom, useAtomValue } from 'jotai';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import styled from 'styled-components';
import useMediaQuerySafe from 'hooks/useMediaQuerySafe';
import { getMaxQueryWidth } from 'helpers/breakpoints';
import { breakpoints } from 'components/search/v2/styleConstants';
import { experienceSubTagOptionsAtom, selectedExperienceTagAtom, selectedExperienceTagTempAtom } from '../filterStore';
import { CheckButton, IconWrapper, CheckIcon } from '../fields/AtomCheckButton';

export const isExperienceSubtagActiveAtom = atom((get) => get(selectedExperienceTagAtom)?.length > 1);
export const isExperienceSubtagHiddenAtom = atom((get) => get(experienceSubTagOptionsAtom)?.length === 0);

export const ExperienceSubTagsLabel = () => {
  const selectedExperienceTags = useAtomValue(selectedExperienceTagAtom);
  let label;
  if (selectedExperienceTags?.length > 0) {
    label = `${
      (selectedExperienceTags[0]?.charAt(0).toUpperCase() ?? '') + (selectedExperienceTags[0]?.slice(1) ?? '')
    } type`;
  } else {
    label = 'Experience type';
  }
  return <span>{label}</span>;
};

export const ExperienceSubTagsContent = ({ isDropdown = false }) => {
  const rudderTrack = useRudderStackTrack();
  const isMobile = useMediaQuerySafe(getMaxQueryWidth(breakpoints.QUICK_FILTER_BOTTOM_SHEET_MAX));
  const atomToUse = isDropdown || isMobile ? selectedExperienceTagTempAtom : selectedExperienceTagAtom;
  const ogSelectedTags = useAtomValue(selectedExperienceTagAtom);
  const [selectedExperienceTags, setSelectedExperienceTag] = useAtom(atomToUse);
  const experienceSubTagOptions = useAtomValue(experienceSubTagOptionsAtom);
  const router = useRouter();

  useEffect(() => {
    if (isDropdown || isMobile) {
      setSelectedExperienceTag(ogSelectedTags);
    }
  }, []);

  useEffect(() => {
    rudderTrack('show', {
      component_type: 'button',
      object: 'experience_subfilter_tile',
      context: 'plp',
      filter_text: experienceSubTagOptions.map((exp) => exp.key).join(', '),
      search_location: router.query.near,
    });
  }, [experienceSubTagOptions]);

  const selectSubTag = (subtag) => {
    let newList;
    if (selectedExperienceTags?.includes(subtag.key)) {
      newList = selectedExperienceTags.filter((tag) => tag !== subtag.key);
    } else {
      newList = [...(selectedExperienceTags || []), subtag.key];
    }
    setSelectedExperienceTag(newList);
    rudderTrack('click', {
      component_type: 'button',
      object: 'experience_subfilter_tile',
      context: 'plp',
      filter_text: subtag.key,
    });
  };
  return (
    <TagWrapper>
      {experienceSubTagOptions.map((tag) => (
        <CheckButton
          key={tag.key}
          checked={selectedExperienceTags?.includes(tag.key)}
          onClick={() => {
            selectSubTag(tag);
          }}
        >
          {tag.display_name}
          <IconWrapper style={{ visibility: selectedExperienceTags?.includes(tag.key) ? 'visible' : 'hidden' }}>
            <CheckIcon />
          </IconWrapper>
        </CheckButton>
      ))}
    </TagWrapper>
  );
};

const TagWrapper = styled.div`
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 16px;

  ${CheckButton} {
    white-space: nowrap;
    padding-left: 40px;
  }
`;
